module.exports = __webpack_public_path__ + "media/customizations/sevenhills/back-5f83f48e0f1f44b2a01d0816e8a4828b.jpg";